export default function Leadership() {
  const leaders = [
    {
      name: 'Michael Ashley',
      position: 'Founder & CEO',
      image: 'https://public.readdy.ai/ai/img_res/30b7b983f67c1e2f9e86ad1958100379.jpg',
      bio: 'Founded TrackVerse in 2020 with a vision to revolutionize global logistics through technology and transparency.'
    },
    {
      name: 'Sarah Chen',
      position: 'Chief Operations Officer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20executive%20in%20her%2030s%20wearing%20elegant%20gray%20business%20suit%20standing%20confidently%20in%20modern%20corporate%20office%20looking%20at%20camera%20with%20professional%20smile%20clean%20white%20background%20corporate%20headshot%20photography%20high%20quality&width=400&height=400&seq=leader2&orientation=squarish',
      bio: 'Oversees global operations across 50+ countries, ensuring seamless logistics and exceptional service delivery.'
    },
    {
      name: 'David Martinez',
      position: 'Chief Technology Officer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20male%20tech%20executive%20in%20his%2030s%20wearing%20modern%20business%20casual%20attire%20standing%20in%20contemporary%20office%20with%20technology%20background%20looking%20at%20camera%20with%20confident%20smile%20clean%20white%20background%20corporate%20headshot%20photography%20high%20quality&width=400&height=400&seq=leader3&orientation=squarish',
      bio: 'Leads innovation in tracking technology and digital solutions, driving TrackVerse\'s technological advancement.'
    },
    {
      name: 'Emma Thompson',
      position: 'Chief Financial Officer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20CFO%20in%20her%2040s%20wearing%20sophisticated%20black%20business%20suit%20standing%20in%20elegant%20office%20environment%20looking%20at%20camera%20with%20professional%20demeanor%20clean%20white%20background%20corporate%20headshot%20photography%20high%20quality&width=400&height=400&seq=leader4&orientation=squarish',
      bio: 'Manages financial strategy and sustainable growth, ensuring TrackVerse\'s continued expansion and stability.'
    },
    {
      name: 'James Wilson',
      position: 'VP of Global Partnerships',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20business%20executive%20in%20his%2040s%20wearing%20charcoal%20gray%20suit%20standing%20in%20modern%20corporate%20setting%20looking%20at%20camera%20with%20friendly%20professional%20smile%20clean%20white%20background%20corporate%20headshot%20photography%20high%20quality&width=400&height=400&seq=leader5&orientation=squarish',
      bio: 'Builds strategic partnerships worldwide, expanding TrackVerse\'s network and service capabilities.'
    },
    {
      name: 'Aisha Patel',
      position: 'VP of Customer Experience',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20female%20executive%20in%20her%2030s%20wearing%20elegant%20teal%20business%20suit%20standing%20confidently%20in%20modern%20office%20looking%20at%20camera%20with%20warm%20welcoming%20smile%20clean%20white%20background%20corporate%20headshot%20photography%20high%20quality&width=400&height=400&seq=leader6&orientation=squarish',
      bio: 'Champions customer satisfaction and service excellence, ensuring every client receives world-class support.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Leadership Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the experienced professionals driving TrackVerse's mission to transform 
            global logistics and deliver exceptional service worldwide.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {leaders.map((leader, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow"
            >
              <div className="w-full h-80 bg-gray-100">
                <img 
                  src={leader.image}
                  alt={leader.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">
                  {leader.name}
                </h3>
                <div className="text-sm font-medium text-blue-600 mb-3">
                  {leader.position}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {leader.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
